import classNames from 'classnames'

import ExportCSVButton from './ExportCSVButton.js'

/**
 * A Pane, not a pain
 *
 * @param {Object} props
 * @param {Boolean} props.isLoading
 * @param {String} props.title
 * @param {React.ReactNode} props.children
 * @param {Boolean} props.canExport
 * @param {Function} props.onExport
 * @returns {React.ReactNode}
 */
export default function Pane({
  isLoading,
  title,
  children,
  canExport,
  onExport,
}) {
  return (
    <div
      className={classNames('panel panel--analytics clearfix', {
        loading: isLoading,
      })}
    >
      <div className="panel__header panel__header--analytics flex--justify">
        <h3 className="subheader subheader--analytics">{title}</h3>
        {canExport && onExport && <ExportCSVButton onExport={onExport} />}
      </div>
      <div className="medium-12 columns">
        <p className="graph-loading" />
        {children}
      </div>
    </div>
  )
}
